/**
 * Format ISO date string to readable format
 * @param {string} isoDate - ISO 8601 date string
 * @returns {string} Formatted date
 */
export const formatDate = (isoDate) => {
  if (!isoDate) return '-';
  
  try {
    const date = new Date(isoDate);
    
    // Check if valid date
    if (isNaN(date.getTime())) return '-';
    
    // Format: Oct 24, 2025, 10:30 AM
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return '-';
  }
};

/**
 * Get relative time (e.g., "2 hours ago")
 * @param {string} isoDate - ISO 8601 date string
 * @returns {string} Relative time
 */
export const getRelativeTime = (isoDate) => {
  if (!isoDate) return '-';
  
  try {
    const date = new Date(isoDate);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    if (diffInSeconds < 60) return 'Just now';
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} minutes ago`;
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} hours ago`;
    if (diffInSeconds < 2592000) return `${Math.floor(diffInSeconds / 86400)} days ago`;
    
    return formatDate(isoDate);
  } catch (error) {
    console.error('Error getting relative time:', error);
    return '-';
  }
};

